// extracted by mini-css-extract-plugin
module.exports = {"originCountriesWrapper":"OriginCountries_originCountriesWrapper__yMkbW","originTitle":"OriginCountries_originTitle__yKaK0"};